var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statistic.show)?_c('td',{class:_vm.theClass,attrs:{"aria-label":_vm.statistic.ariaLabel,"title":_vm.statistic.hoverTitle}},[_vm._v(" "+_vm._s(_vm.statistic.footnote)+" "+_vm._s(_vm.statistic.formattedValue)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }